import { IconBuildingStore, IconPackage } from "@tabler/icons-react";
import { useNavigate } from "react-router-dom";
import { Button } from "../../../../../../components/common/button";
import { SelectionCard } from "../../../../../../components/common/selection-card";
import { CreatePartnerDtoPartnerTypeEnum } from "../../../../../../api";
import { AppRoutes } from "../../../../../../common/routes/app_routes";
import { useRegisterWizard } from "../../../../domain/register-wizard";
import RegisterWizardLayout from "./register-wizard-layout";
import { DevAutofillButton } from "./dev-autofill-button";

export function PartnerTypeStep() {
  const navigate = useNavigate();
  const { partnerType, setPartnerType } = useRegisterWizard();

  const onContinue = () => {
    if (!partnerType) return;
    navigate(AppRoutes.CREATE_ACCOUNT_BUSINESS_DETAILS);
  };

  return (
    <RegisterWizardLayout
      title="Partner Type"
      progress={{ current: 1, total: 3 }}
      onBack={() => navigate(AppRoutes.CREATE_ACCOUNT)}
    >
      <div className="flex w-full flex-col gap-6 sm:flex-row">
        <SelectionCard
          icon={<IconBuildingStore size={22} />}
          title="Buyer"
          description="Browse products, request quotes, and manage orders"
          selected={partnerType === CreatePartnerDtoPartnerTypeEnum.Buyer}
          onClick={() => setPartnerType(CreatePartnerDtoPartnerTypeEnum.Buyer)}
        />
        <SelectionCard
          icon={<IconPackage size={22} />}
          title="Seller"
          description="List products and manage fulfillment"
          selected={partnerType === CreatePartnerDtoPartnerTypeEnum.Seller}
          onClick={() => setPartnerType(CreatePartnerDtoPartnerTypeEnum.Seller)}
        />
      </div>

      <Button
        variant="primary"
        fullWidth
        onClick={onContinue}
        disabled={!partnerType}
      >
        Continue
      </Button>
      <DevAutofillButton
        onClick={() => setPartnerType(CreatePartnerDtoPartnerTypeEnum.Buyer)}
        label="Dev: Autofill (Buyer)"
      />
    </RegisterWizardLayout>
  );
}

export default PartnerTypeStep;
